<div class="hero-section">
    <div class="floating-shapes">
        <div class="shape circle"></div>
        <div class="shape square"></div>
        <div class="shape triangle"></div>
    </div>
    <div class="content">
        <h1>Your SaaS Solution, <span>Reimagined</span></h1>
        <p>Experience seamless, scalable, and secure software for your business needs.</p>
        <a href="products" class="cta-button">Learn More</a>
    </div>
</div>
